import React from 'react';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children, roles }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    return <Navigate to="/login" replace />;
  }
  
  try {
    const user = JSON.parse(userStr);
    if (roles && !roles.includes(user.role)) {
      return <Navigate to="/login" replace />;
    }
  } catch (e) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;